<template>
      <div class="recommend_title text-green"> 公司荣誉</div>
  <div class="swiper-simple-container">
    <swiper
      :slides-per-view="3"
      :space-between="0"
      :centered-slides="true"
      :centered-slides-bounds="true"
      :loop="true"
  
      :navigation="{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        hideOnClick: true,
      }"
      :pagination="{
        clickable: true,
        el: '.swiper-pagination',
      }"
      :autoplay="{
        delay: 3000,
        disableOnInteraction: false,
      }"
      :modules="modules"
      class="swiper-simple"
      @swiper="onSwiper"
    >
      <swiper-slide v-for="(img,index) in swiperImgs" :key="index">
        <div class="swiper-slide-content">
          <img :src="require(`@/assets/images/${img.url}`)" style="width: 100%;height: 100%;">
        </div>
      </swiper-slide>
       <div class="swiper-button-prev"></div><!--左箭头。如果放置在swiper外面，需要自定义样式。-->
      <div class="swiper-button-next"></div><!--右箭头。如果放置在swiper外面，需要自定义样式。-->
    </swiper>
    
    <!-- 分页器 -->
    <div class="swiper-pagination"></div>
    

  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay,Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
const modules = [Autoplay, Navigation, Pagination]
const swiperInstance = ref(null)
const swiperImgs=[
  {url:"home_honor1.jpg"},
  {url:"home_honor2.jpg"},
  {url:"home_honor3.jpg"}
]
const onSwiper = (swiper) => {
  swiperInstance.value = swiper
}


</script>

<style scoped>

.recommend_title {
  font-size: 20px;
  line-height: 65px;
  margin-top: 10px;
  text-align: center;

}

.swiper-simple-container {
  width: 1200px;
  margin: 0 auto;
  height: 395px;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.swiper-simple {
  width: 100%;
  height: 100%;
  margin-bottom: 30px;
}



/* 激活的 Slide - 宽度 700px */
:deep(.swiper-slide-active) {
  width: 700px !important;
  z-index: 10;
  transform: scale(1) !important;
}

/* 左右相邻的 Slide */
:deep(.swiper-slide-prev),
:deep(.swiper-slide-next) {
  width: 250px !important;
  height: 100% !important;
  transform: translateX(0) !important;
  opacity: 0.6;
}



:deep(.swiper-slide) {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

:deep(.swiper-slide-active),
:deep(.swiper-slide-duplicate-active) {
  transform: scale(1);
  background: #47484a;
  color: white;
  font-weight: bold;
  box-shadow: 0 10px 30px rgba(31, 31, 31, 0.3);
}

.swiper-slide-content {
  font-size: 24px;
  font-weight: bold;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}


.swiper-simple .swiper-button-prev,
.swiper-simple .swiper-button-next {
  opacity: 0.2;
  transition: opacity 0.3s;
}

.swiper-simple:hover .swiper-button-prev,
.swiper-simple:hover .swiper-button-next {
  opacity: 1;
}

/* 修改箭头颜色为绿色 */
.swiper-simple .swiper-button-prev ,
.swiper-simple .swiper-button-next  {
  color: #6e9f40 !important;

}
.swiper-pagination {
  position: relative !important;
  margin: 20px 0;
}

:deep(.swiper-pagination-bullet) {
  background: #ccc;
}

:deep(.swiper-pagination-bullet-active) {
  background: #6e9f40;
}

.ant-actions {
  margin-top: 20px;
}
</style>